import { css } from '@emotion/core';

import { minTablet, minDesktop } from '../styles/breakpoints';
import { TextColor, SecondaryTextColor } from '../styles/colors';
import { HeadlineFont } from '../styles/fonts';

export const SectionHeadlineFontStyles = css`
  color: ${TextColor};

  font-size: 18px;
  ${minTablet} {
    font-size: 20px;
  }
  ${minDesktop} {
    font-size: 22px;
  }
`;

export const SectionHeadline2ndFontStyles = css`
  ${HeadlineFont};

  color: ${TextColor};

  font-size: 24px;
  ${minTablet} {
    font-size: 28px;
  }
  ${minDesktop} {
    font-size: 32px;
  }
`;

export const SectionIdFontStyles = css`
  ${HeadlineFont};

  color: ${SecondaryTextColor};

  font-size: 24px;
  ${minTablet} {
    font-size: 32px;
  }
  ${minDesktop} {
    font-size: 44px;
    margin-top: -.2em;
  }
`;

export const TextFontStyles = css`
  color: ${TextColor};
  font-size: 18px;
`;



// WEBPACK FOOTER //
// ./src/components/ExternalLinksCollection/styles.js